/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb4cbeeaaeee3c5fe2b0f7fcbb5a548a>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Tree".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Nature emoji category.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TreeIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .62.329l4.75 7a.75.75 0 0 1-.62 1.171h-.466l2.558 3.29A.75.75 0 0 1 14.25 13H10.5v1.625c0 .76-.616 1.375-1.375 1.375h-2.25c-.76 0-1.375-.616-1.375-1.375V13H1.75a.75.75 0 0 1-.592-1.21L3.717 8.5H3.25a.75.75 0 0 1-.62-1.171l4.75-7A.75.75 0 0 1 8 0M4.665 7h.585a.75.75 0 0 1 .592 1.21L3.283 11.5H6.25a.75.75 0 0 1 .75.75v2.25h2v-2.25a.75.75 0 0 1 .75-.75h2.967l-2.559-3.29A.75.75 0 0 1 10.75 7h.585L8 2.086z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TreeIcon.displayName = 'TreeIcon';
var _default = exports.default = TreeIcon;